import React from 'react';
import { compose } from 'redux';

import { withFunctionalClassName } from 'common/src/app/util/componentClassNameUtils';
import ComponentType from 'common/src/app/data/enum/ComponentType';

import Wrapper from '../../atoms/Wrapper';

import './header.scss';

type HeaderProps = {
  children?: React.ReactNode;
  center?: React.ReactNode;
  top?: React.ReactNode;
  bottom?: React.ReactNode;
  headerRef?: React.RefObject<HTMLElement>;
};

const Header = (
  { children, center, top, bottom, headerRef }: HeaderProps,
  {},
  className: string,
  dataTestId: string,
): JSX.Element => {
  const addWrapper = (content: React.ReactNode, wrapperProps?: Record<string, unknown>) => (
    <Wrapper width="xl" {...wrapperProps}>
      {content}
    </Wrapper>
  );

  return (
    <header className={className} data-testid={dataTestId} ref={headerRef}>
      {top && addWrapper(top)}
      {addWrapper(
        <>
          {children}
          {center && <div className="header-center">{center}</div>}
        </>,
        { background: 'primary-light', cid: 'main-content' },
      )}
      {bottom && addWrapper(bottom, { background: 'primary-light', cid: 'bottom-content' })}
    </header>
  );
};

type HeaderType = (props: HeaderProps) => JSX.Element;

export default compose<HeaderType>(withFunctionalClassName(ComponentType.ORGANISM, 'Header'))(
  Header,
);
